import i18n from '@dms/i18n';

const categoryTranslationKeys: Partial<Record<number, string>> = {
  1: 'page.vehicleDetail.automarketplInspection.categories.1',
  2: 'entity.inspection.section.INTERIOR',
  3: 'page.vehicleDetail.automarketplInspection.categories.3',
  4: 'page.vehicleDetail.automarketplInspection.categories.4',
  5: 'page.vehicleDetail.automarketplInspection.categories.5',
  6: 'page.vehicleDetail.automarketplInspection.categories.6',
};

export function getAutomarketplInspectionCategoryLabel(categoryId: number) {
  return i18n.t(categoryTranslationKeys[categoryId] ?? 'module.inspection.title');
}
